<template>
    <div class="card">
        <div class="bg-blue-light p-1">
            <TitleButton 
                :showBtn="false"
                title="Current Stage"
                :showAddNew="false"
            />
        </div>

        <div class="col-12 px-2 mt-2 mb-4">
          <div class="card p-2" style="min-height: 200px">
            <div class="table-responsive">
              <table class="table table-bordered">
                <thead>
                <tr>
                  <th>SL No</th>
                  <th class="text-center">Stage</th>
                  <th class="text-center">Total Count</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, i) in tableItems" :key="i">
                  <td> {{ i+1 }}</td>
                  <td class="text-center"> {{ item.name }}</td>
                  <td class="text-center"> {{ item.total_pipeline }}</td>
                </tr>
                </tbody>
              </table>
              <p v-if="tableItems.length < 0" class="text-center mt-5">No data</p>
            </div>
          </div>
        </div>

        <Loader v-if="loading"/>

    </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import { inject, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Loader from '@/components/atom/LoaderComponent'
import handleAdmin from '@/services/modules/admin/admin';

const store = useStore();
const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const loading = ref(false)
const tableItems = ref([]);
const params = ref({
    offset: 10,
});

const {
  fetchCrmCurrentStageData
} = handleAdmin();

const getCurrentStageData = async () => {
    const query = getQuery();
    loading.value = true
    tableItems.value = []
    await fetchCrmCurrentStageData(query).then(res => {
        if (!res.status){
            return
        }

     tableItems.value = res.data;
    }).catch(err => {
        console.log(err)
    }).finally(() => {
        loading.value = false
    })
}

const getQuery = () => {
    return `?company_id=${route.params.companyId}`;
}

onMounted(() => {
    Promise.all([
      getCurrentStageData(),
    ])
})
</script>
